export type Translations = Record<string, Record<string, string>>

export const translations: Translations = {
  nature: {
    good: 'Bem',
    service: 'Serviço'
  }
}
